module.exports = __webpack_public_path__ + "img/icon_pos.b7951c04.png";